import { useQuery } from "@tanstack/react-query";

import { getTeacherFinalAssessmentApiCall } from "./utils.api";
import { teacherFinalAssessmentKeys } from "../../../redux/services/teacherFinalAssessmentKeys";

export const useGetTeacherFinalAssessmentDetails = (teacherId) => {
  return useQuery({
    queryKey: teacherFinalAssessmentKeys.getTeacherFinalAssessmentKeys({ teacherId }),
    queryFn: () => getTeacherFinalAssessmentApiCall(teacherId),
    enabled: Boolean(teacherId),
  });
};
